<template>
	<div class="login">
		<div class="infoform">
			<div class="textlogin">
				<span>欢迎登录</span>
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm">
				<el-form-item prop="account">
					<el-input prefix-icon="el-icon-user" v-model="ruleForm.account" placeholder="请输入账号"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input prefix-icon="el-icon-lock" v-model="ruleForm.password" placeholder="请输入密码" show-password>
					</el-input>
				</el-form-item>
			</el-form>
			<div class="newuser">
				<el-link type="primary" @click="gotoregister()">新用户注册</el-link>
			</div>
			<div class="forgetpassword">
				<el-link type="primary" @click="gotofoegetpass()">忘记密码…</el-link>
			</div>
			<div class="roundbtn">
				<el-button type="primary" round class="lgoinbtn" @click="postlogin()">登录</el-button>
			</div>
			<div class="footer">
				<div class="container">
					<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
						技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
						<br />吉公网安备 22010402001082号
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import {
		userLogin,
	} from '../api/user.js'
	export default {
		data() {
			var validateAccount = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入账号'));
				} else if (value.length != 11) {
					callback(new Error('请输入正确的账号'));
				} else {
					callback();
				}
			};
			var validatePassword = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else if (value.length >= 8 && value.length <= 15) {
					callback();
				} else {
					callback(new Error('请输入正确密码'));
				}
			};
			return {
				ruleForm: {
					account: '',
					password: '',
				},
				rules: {
					account: [{
						validator: validateAccount,
						trigger: 'blur'
					}, ],
					password: [{
						validator: validatePassword,
						trigger: 'blur'
					}, ],
				},
			};
		},
		methods: {
			postlogin() {
				if (this.ruleForm.account != '' && this.ruleForm.password != '') {
					userLogin({
						userID: this.ruleForm.account,
						password: this.ruleForm.password,
					}).then(res => {
						if (res.code == 50011) {
							this.$message({
								message: '用户名不存在！',
								type: 'error'
							});
						} else if (res.code == 40015) {
							this.$message({
								message: '您的密码有误！',
								type: 'error'
							});
						} else if (res.code == 200) {
							this.$message({
								message: '登录成功！',
								type: 'success'
							});
							this.$router.push('/')
						} else if (res.code == 300) {
							this.$message({
								message: '登录成功！',
								type: 'success'
							});
							this.$router.push('/management/addPosition')
						}
					})
				} else {
					this.$message({
						message: '用户名与密码不能为空！',
						type: 'warning'
					});
				}

			},
			gotoregister() {
				this.$router.push('/register')
			},
			gotofoegetpass() {
				this.$router.push('/forgetpass')
			},
		},
	}
</script>

<style scoped>
	.login {
		position: fixed;
		left: 0;
		top: 0;
		background: url('../image/loginbackground.jpg');
		background-size: 100% 100%;
		width: 100%;
		height: 100%;
	}

	.infoform {
		background-color: white;
		width: 450px;
		height: 350px;
		margin: auto;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		border-radius: 4px;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		padding-bottom: 25px;
	}

	.textlogin {
		font-size: 22px;
		padding-top: 4%;
		padding-left: 181px;
	}

	.el-form {
		margin-left: 5%;
		margin-right: 5%;
		font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	}

	.el-form-item {
		margin-top: 10%;
	}

	.newuser {
		margin-top: -11px;
		margin-left: 22.5px;
		width: 70px;
	}

	.forgetpassword {
		margin-top: -21px;
		margin-left: 357.5px;
		width: 70px;
	}

	.lgoinbtn {
		margin-top: 20px;
		width: 120px;
		height: 45px;
		margin-left: 165px;
	}

	.roundbtn {
		width: 450px;
	}
	
	.footer{
		margin-top: 10px;
	}
</style>
